import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户信息
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    // 侧边栏折叠状态
    sidebarCollapse: false,
    // 站点设置
    siteSetting: {}
  },
  mutations: {
    // 设置用户信息
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    // 清空用户信息
    CLEAR_USER_INFO(state) {
      state.userInfo = {}
      localStorage.removeItem('userInfo')
      localStorage.removeItem('token')
    },
    // 切换侧边栏折叠状态
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapse = !state.sidebarCollapse
    },
    // 设置站点配置
    SET_SITE_SETTING(state, siteSetting) {
      state.siteSetting = siteSetting
    }
  },
  actions: {
    // 登录
    login({ commit }, loginForm) {
      return new Promise((resolve, reject) => {
        axios.post('/admin/passport/acc/login', loginForm)
          .then(response => {
            const { data } = response
            if (data.code === 200) {
              // 保存token
              localStorage.setItem('token', data.data.token)
              // 保存用户信息
              commit('SET_USER_INFO', data.data.userInfo)
              resolve(data)
            } else {
              reject(data.msg || '登录失败')
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_USER_INFO')
    },
    // 获取站点设置
    getSiteSetting({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/admin/siteSetting')
          .then(response => {
            const { data } = response
            if (data.code === 200) {
              commit('SET_SITE_SETTING', data.data)
              resolve(data.data)
            } else {
              reject(data.msg || '获取站点设置失败')
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {
    // 获取用户名
    username: state => {
      return state.userInfo.username || ''
    },
    // 站点名称
    siteName: state => {
      return state.siteSetting.companyName || '斯林百兰管理系统'
    },
    // 站点Logo
    siteLogo: state => {
      return state.siteSetting.logo || ''
    }
  }
}) 